import { useEffect } from 'react';

export function useAsyncEffect<V>(
  effect: (isMounted: () => boolean) => V | Promise<V>,
  inputs?: any[],
  destroy?: (result?: V) => void,
): void {
  const hasDestroy = typeof destroy === 'function';

  useEffect(
    function () {
      let result: V;
      let mounted = true;
      const maybePromise = effect(function () {
        return mounted;
      });

      Promise.resolve(maybePromise).then(function (value) {
        result = value;
      });

      return function () {
        mounted = false;

        if (hasDestroy) {
          destroy && destroy(result);
        }
      };
    },

    hasDestroy ? inputs : [destroy],
  );
}
